const utilityConfig = {
    url : process.env.REACT_APP_UTILITY_URL
};
  
export default utilityConfig;